/* template */
<template><page><base-container :class='["cascade-picker-page"]'><div :class='["btn-item"]'><basic-picker/></div><div :class='["btn-item"]'><slot-picker/></div><div :class='["btn-item"]'><async-picker/></div></base-container></page></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_5ef0ede6"}'>
.btn-item
  margin-bottom 15px
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_5ef0ede6"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_5ef0ede6"}
  /** script content **/
  require("./index.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=page&index=0&isPage&lang=js&mpx&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_5ef0ede6"],
    ctorType: "page",
    outputPath: "",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'base-container':getComponent(require("../../components/base-container/index.mpx?isComponent&outputPath=components%2Findexa53ae8d2%2Findex")),'basic-picker':getComponent(require("./basic-picker.mpx?isComponent&outputPath=components%2Fbasic-picker8418a540%2Findex")),'slot-picker':getComponent(require("./slot-picker.mpx?isComponent&outputPath=components%2Fslot-picker2e019af8%2Findex")),'async-picker':getComponent(require("./async-picker.mpx?isComponent&outputPath=components%2Fasync-picker21912252%2Findex")),'cube-divider':getComponent(require("../../../packages/mpx-cube-ui/src/components/divider/index.mpx?isComponent&outputPath=components%2Findex731ea706%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>